module.exports = __webpack_public_path__ + "img/media (7).56316bf5.png";